// @flow

export type PaymentTermConfigurationType = 'term' | 'direct'

class PaymentTermConfiguration {
  type: PaymentTermConfigurationType
  nrOfTerms: ?number
}

const buildPaymentTermConfiguration = function (type: PaymentTermConfigurationType, nrOfTerms: ?number): PaymentTermConfiguration {
  const paymentTermConfiguration = new PaymentTermConfiguration()
  paymentTermConfiguration.type = type
  paymentTermConfiguration.nrOfTerms = nrOfTerms
  return paymentTermConfiguration
}

export {
  buildPaymentTermConfiguration,
  PaymentTermConfiguration
}



// WEBPACK FOOTER //
// ./src/types/payment-term-configuration.js